import { useState } from 'react';
import classNames from 'classnames';

import {
  Modal,
  ModalProps,
} from '@ui/Modal';
import { Button } from '@ui/Button';

// styles
import s from './ConfirmActionModal.sss';

// types
export type ConfirmActionModalProps = ModalProps & {
  isOpen: boolean;
  onConfirm: () => void | Promise<unknown>;
  confirmButtonText: string;
  cancelButtonText: string
};

export const ConfirmActionModal: React.FC<React.PropsWithChildren<ConfirmActionModalProps>> = ({
  isOpen,
  onRequestClose,
  onConfirm,
  confirmButtonText,
  cancelButtonText,
  children,
  className,
  withClose = true,
}) => {
  const [isConfirming, setIsConfirming] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      withClose={withClose}
      className={classNames(s.root, className)}
    >
      {children}

      <div className={s.actionButtons}>
        <Button
          className={s.actionButton}
          theme="secondary"
          onClick={onRequestClose}
        >
          {cancelButtonText}
        </Button>
        <Button
          className={s.actionButton}
          theme="primary"
          disabled={isConfirming}
          onClick={
            async () => {
              setIsConfirming(true);
              try {
                await onConfirm();
              } finally {
                setIsConfirming(false);
              }
            }
          }
        >
          {confirmButtonText}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
